import React from 'react';
import { MessageSquare, Mail, XCircle } from 'lucide-react';
import { ReconMatchResult, generateVendorNudge } from '../../services/reconciliationService';
import { toast } from '../ui';

interface Props {
  selectedNudgeItem: ReconMatchResult | null;
  onClose: () => void;
  clientLegalName: string;
  activeGstin: string;
}

export const VendorNudgeModal: React.FC<Props> = ({
  selectedNudgeItem,
  onClose,
  clientLegalName,
  activeGstin
}) => {
  if (!selectedNudgeItem) return null;

  const nudge = generateVendorNudge(
    selectedNudgeItem.invoice,
    clientLegalName,
    activeGstin
  );

  const handleSendWhatsAppWeb = () => {
    window.open(nudge.whatsappUrl, '_blank');
    toast.success('WhatsApp Web dispatch opened for vendor follow-up');
  };

  const handleSendEmailClient = () => {
    window.open(nudge.mailToUrl, '_blank');
    toast.success('Email composer opened');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4 overflow-y-auto">
      <div className="relative w-full max-w-lg rounded-2xl border border-[rgba(247,247,248,0.14)] bg-[#131316] p-6 shadow-2xl space-y-4 text-xs">
        <div className="flex items-center justify-between border-b border-white/10 pb-3">
          <div className="flex items-center gap-2">
            <MessageSquare className="h-5 w-5 text-emerald-400" />
            <div>
              <h3 className="font-bold text-white text-sm">Vendor ITC Follow-up Nudge</h3>
              <p className="text-[11px] text-slate-400">
                Invoice #{selectedNudgeItem.invoice.invoice_number} &bull; ₹{selectedNudgeItem.invoice.total_tax} ITC at risk
              </p>
            </div>
          </div>
          <button onClick={onClose} className="text-slate-400 hover:text-white">
            <XCircle className="h-5 w-5" />
          </button>
        </div>

        <div className="space-y-2">
          <label className="text-[10px] font-bold uppercase text-slate-400">Email Subject</label>
          <div className="rounded-xl border border-white/10 bg-[#0e1015] p-2.5 font-medium text-white">
            {nudge.subject}
          </div>
        </div>

        <div className="space-y-2">
          <label className="text-[10px] font-bold uppercase text-slate-400">Pre-Formatted Message</label>
          <div className="rounded-xl border border-white/10 bg-[#0e1015] p-3 text-slate-300 font-mono text-[11px] whitespace-pre-line leading-relaxed max-h-48 overflow-y-auto">
            {nudge.body}
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 pt-2 border-t border-white/10">
          <button
            onClick={handleSendEmailClient}
            className="flex items-center gap-1.5 rounded-xl border border-white/10 bg-white/5 hover:bg-white/10 text-slate-200 px-3.5 py-2 font-semibold transition"
          >
            <Mail className="h-4 w-4 text-cyan-400" />
            <span>Open Email</span>
          </button>
          <button
            onClick={handleSendWhatsAppWeb}
            className="flex items-center gap-1.5 rounded-xl bg-emerald-500 hover:bg-emerald-400 text-black px-4 py-2 font-bold transition shadow-sm"
          >
            <MessageSquare className="h-4 w-4" />
            <span>Send WhatsApp Nudge</span>
          </button>
        </div>
      </div>
    </div>
  );
};
